/* sj-build whitescreen-fix v2 (is-empty sync) 2026-06-03 */
(function () {
    if (window.__snugjooyCartInit) return;
    window.__snugjooyCartInit = true;

    var R = window.routes || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart' };
    var ADD    = R.cart_add_url    || '/cart/add';
    var CHANGE = R.cart_change_url || '/cart/change';
    var CARTURL = R.cart_url       || '/cart';

    // Variant IDs (espelham o Liquid acima). KNEE/HELMET são os PAGOS reais;
    // a Discount Function "snugjooy-gift" zera 1un quando o tier qualifica.
    var V = {
      knee:       44016388735110,
      helmet:     44016388964486,
      kneeGift:   44016637771910,
      helmetGift: 44016637804678,
      warranty:   44016625221766,
      shipping:   44016625254534
    };
    var TIER = {
      43992875991174:1, 43994747666566:1, 43994747699334:1, 43994747732102:1,
      43992876023942:2, 43994747764870:2, 43994747797638:2, 43994747830406:2,
      43992876056710:3, 43994747863174:3, 43994747895942:3, 43994747928710:3
    };
    // mapa tier x design -> variant (para swap de quantidade = troca de tier)
    var TIER_DESIGN = {
      'Sitting':    { 'Bee':43992875991174, 'Unicorn':43994747666566, 'Turtle':43994747699334, 'Astronaut':43994747732102 },
      'Crawling': { 'Bee':43992876023942, 'Unicorn':43994747764870, 'Turtle':43994747797638, 'Astronaut':43994747830406 },
      'First Steps':    { 'Bee':43992876056710, 'Unicorn':43994747863174, 'Turtle':43994747895942, 'Astronaut':43994747928710 }
    };
    var TIER_ORDER = ['Sitting','Crawling','First Steps'];
    var VARIANT_INFO = {}; // variant_id -> {tier, design}
    Object.keys(TIER_DESIGN).forEach(function(tn){ Object.keys(TIER_DESIGN[tn]).forEach(function(d){ VARIANT_INFO[TIER_DESIGN[tn][d]] = { tier: tn, design: d }; }); });
    // preço de tabela (riscado) e preço atual por tier — base do savings do bundle
    var BUNDLE_COMPARE = { 1: 54, 2: 108, 3: 162 };
    var BUNDLE_NOW     = { 1: 38, 2: 69.70, 3: 99.90 };

    // ---- imagens dos designs (head protector) e do brinde knee, por design ----
    var CDN = 'https://cdn.shopify.com/s/files/1/0659/1047/2838/t/3/assets/';
    var DESIGN_SET = { 'Bee': 1, 'Unicorn': 1, 'Turtle': 1, 'Astronaut': 1 };
    function headImg(d)     { return CDN + 'snugly-variant-' + String(d).toLowerCase() + '.webp'; }
    function kneeGiftImg(d) { return CDN + 'snugly-gift-knee-' + String(d).toLowerCase() + '.png'; }
    // fotos lifestyle bonitas das variantes (turtle e .png, resto .webp)
    var CART_IMG = {
      'Bee':       CDN + 'snugly-cart-bee.webp',
      'Unicorn':   CDN + 'snugly-cart-unicorn.webp',
      'Turtle':    CDN + 'snugly-cart-turtle.png',
      'Astronaut': CDN + 'snugly-cart-astronaut.webp'
    };
    function cartImg(d) { return CART_IMG[d] || headImg(d); }

    // designs escolhidos no bundle: Design 1 = variant (option2), Design 2/3 = properties
    function chosenDesigns(item) {
      var ds = [];
      if (!item) return ds;
      var info = VARIANT_INFO[item.variant_id];
      if (info && info.design) ds.push(info.design);
      var props = item.properties || {};
      ['Design 2', 'Design 3'].forEach(function (k) {
        var val = props[k];
        if (val && DESIGN_SET[val]) ds.push(val);
      });
      return ds;
    }

    function injectDecorCSS() {
      if (document.getElementById('sj-decor-css')) return;
      var s = document.createElement('style');
      s.id = 'sj-decor-css';
      s.textContent =
        '.cart-item--product-snugjooy-baby-head-protector .cart-item__media img{object-fit:contain!important;background:#f5f1fb}' +
        '.sj-main-thumb{width:100%;height:auto;object-fit:contain;border-radius:8px;background:#f5f1fb;display:block}' +
        '.sj-chosen-variants{display:flex;gap:6px;flex-wrap:wrap;margin:6px 0 2px}' +
        '.sj-cv{display:flex;flex-direction:column;align-items:center;width:46px}' +
        '.sj-cv img{width:46px;height:46px;object-fit:cover;border-radius:8px;background:#f5f1fb;border:1px solid #ececf2;display:block}' +
        '.sj-cv b{font-size:9px;font-weight:700;color:#444;margin-top:3px;line-height:1.1;text-align:center}' +
        // QA carrinho (bugs reportados): remover fileira de bandeiras de pagamento (confunde com os botoes Apple/PayPal/GPay)
        'cart-drawer .payment-badges-block,cart-drawer .payment-badges{display:none!important}' +
        // brinde incluido ($0) NAO tem quantidade editavel -> esconde o stepper (era o "segundo contador" confuso)
        'cart-drawer .cart-item[class*="included-gift"] .quantity,cart-drawer .cart-item[class*="included-gift"] quantity-input{display:none!important}' +
        // brinde incluido nao se REMOVE manualmente (reconcile re-adiciona = "pisca"): esconde a lixeira
        'cart-drawer .cart-item[class*="included-gift"] cart-remove-button,cart-drawer .cart-item[class*="included-gift"] .cart-item__remove{display:none!important}' +
        // loading suave: durante a atualizacao o corpo do drawer atenua (transicao premium, sem pulo)
        'cart-drawer .cart-drawer__body{transition:opacity .2s ease}' +
        'cart-drawer.sj-busy .cart-drawer__body{opacity:.5;pointer-events:none}' +
        // cronometros (Matheus): remove o de cima (.cart-timer do tema) e deixa so o de baixo (.sj-timer)
        'cart-drawer .cart-timer{display:none!important}' +
        // timer unico de baixo em VERMELHO (era roxo)
        '.sj-timer{background:#dc2626!important}';
      document.head.appendChild(s);
    }

    // decorateImages: troca a head genérica do item principal pelos designs escolhidos
    // e correlaciona a foto do brinde knee ao 1º design. Idempotente (data-sj-designs).
    // ancora o valor do brinde: preco original riscado ($9/$19) ao lado do $0.00 — recupera a
    // ancoragem que saiu do bloco INCLUDED (Matheus 2026-06-03). Idempotente via data-sj-anchored.
    function anchorGiftPrices() {
      Array.prototype.forEach.call(document.querySelectorAll('cart-drawer .cart-item[class*="included-gift"]'), function (li) {
        if (li.getAttribute('data-sj-anchored')) return;
        var price = li.querySelector('.price--end, .cart-item__price-wrapper, .cart-item__price');
        if (!price) return;
        var s = document.createElement('s');
        s.className = 'sj-gift-was';
        s.textContent = /helmet/i.test(li.className) ? '$19' : '$9';
        s.style.cssText = 'color:#9a96ad;font-weight:500;margin-right:6px';
        price.parentNode.insertBefore(s, price);
        li.setAttribute('data-sj-anchored', '1');
      });
    }
    function decorateImages() {
      return getCart().then(function (cart) {
        injectDecorCSS();
        anchorGiftPrices();
        var main = mainBundleItem(cart);
        // stepper do item principal mostra as UNIDADES do bundle (Sitting=1, Crawling=2, First Steps=3),
        // nao a qtd da linha (Matheus: "leva 2 e aparece 1"). So display — o swapMain segue por tier.
        if (main && VARIANT_INFO[main.variant_id]) {
          var units = (TIER_ORDER.indexOf(VARIANT_INFO[main.variant_id].tier) + 1) * (main.quantity || 1);
          var liU = document.querySelector('cart-drawer .cart-item--product-snugjooy-baby-head-protector');
          var inp = liU && liU.querySelector('input[name="updates[]"], input.quantity__input');
          if (inp) { inp.value = units; inp.setAttribute('value', units); }
        }
        var designs = main ? chosenDesigns(main) : [];
        if (!designs.length) return;
        var key = designs.join(',');

        // 1) item principal: thumbnail = foto bonita do 1o design; details = variantes individuais (foto + nome)
        var liMain = document.querySelector('.cart-item--product-snugjooy-baby-head-protector');
        if (liMain && liMain.getAttribute('data-sj-designs') !== key) {
          // thumbnail = imagem nativa da variante (foto do design, associada no Shopify) -> sem flash
          // esconde o DL cru de variantes (First Steps / Bee, Design 2: ...)
          var dl = liMain.querySelector('dl');
          if (dl) dl.style.display = 'none';
          // chips individuais: cada design escolhido com sua foto bonita + nome
          var details = liMain.querySelector('.cart-item__details');
          if (details) {
            var oldCv = details.querySelector('.sj-chosen-variants');
            if (oldCv) oldCv.remove();
            var chips = document.createElement('div');
            chips.className = 'sj-chosen-variants';
            chips.innerHTML = designs.map(function (d) {
              return '<span class="sj-cv"><img src="' + cartImg(d) + '" alt="' + d + '" loading="lazy"><b>' + d + '</b></span>';
            }).join('');
            var h4 = details.querySelector('.cart-item__name');
            if (h4 && h4.nextSibling) details.insertBefore(chips, h4.nextSibling);
            else details.appendChild(chips);
          }
          liMain.setAttribute('data-sj-designs', key);
        }

        // 2) brinde knee: usa a imagem nativa (featured do produto = foto real verde). Sem override JS.
      }).catch(function (e) { console.error('[snugjooy] decorate', e); });
    }

    // qtys incluídas (grátis via Function) por tier
    function includedKnee(tier)   { return tier >= 2 ? 1 : 0; }
    function includedHelmet(tier) { return tier >= 3 ? 1 : 0; }

    function panel() { return document.querySelector('.snugjooy-cart'); }
    function drawer() { return document.querySelector('cart-drawer'); }

    function sectionIds() {
      var d = drawer();
      if (d && typeof d.getSectionsToRender === 'function') {
        try { return d.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) {}
      }
      return ['cart-drawer', 'cart-icon-bubble'];
    }

    function setBusy(on) {
      var p = panel();
      if (p) p.classList.toggle('is-busy', !!on);
      // loading suave premium: atenua o corpo do drawer durante a atualizacao (evita o "pulo"
      // de estado quando troca de tier leva ~1-2s). Volta sozinho ao terminar a userAction.
      var dr = drawer();
      if (dr) dr.classList.toggle('sj-busy', !!on);
    }

    function getCart() {
      return fetch(CARTURL + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); });
    }

    function qtyOf(items, vid) {
      var n = 0;
      (items || []).forEach(function (i) { if (i.variant_id === vid) n += i.quantity; });
      return n;
    }

    function cartTier(items) {
      var t = 0;
      (items || []).forEach(function (i) {
        var v = TIER[i.variant_id];
        if (v && v > t) t = v;
      });
      return t;
    }

    function post(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    }

    // setLine: leva a variant `vid` para a quantidade `target` (add se 0->N, senão change).
    function setLine(vid, target) {
      var ids = sectionIds();
      return getCart().then(function (cart) {
        var cur = qtyOf(cart.items, vid);
        if (cur === 0 && target > 0) {
          return post(ADD, { items: [{ id: vid, quantity: target }], sections: ids, sections_url: window.location.pathname });
        }
        return post(CHANGE, { id: String(vid), quantity: target, sections: ids, sections_url: window.location.pathname });
      });
    }

    // item principal do bundle no carrinho (o que tem variant de tier)
    function mainBundleItem(cart) {
      var arr = (cart.items || []);
      for (var i = 0; i < arr.length; i++) { if (VARIANT_INFO[arr[i].variant_id]) return arr[i]; }
      return null;
    }

    // swapMain: stepper do item principal = troca de TIER (1=Sitting,2=Crawling,3=First Steps),
    // acima de 3 multiplica First Steps (mesmo $/un). dir = +1 ou -1. Preserva o design e as properties.
    // stepper do item principal = troca de TIER (1=Sitting,2=Crawling,3=First Steps),
    // acima de 3 multiplica First Steps (mesmo $/un). dir = +1 ou -1. Preserva design + properties.
    // (Comportamento ORIGINAL confirmado por Matheus 2026-06-03: o salto de bundle e intencional —
    // o bundle E a quantidade com desconto progressivo. Sitting + => Crawling = "comprar 2".)
    function swapMain(dir) {
      var ids = sectionIds();
      return getCart().then(function (cart) {
        var it = mainBundleItem(cart);
        if (!it) return null;
        var info = VARIANT_INFO[it.variant_id];
        var tier = info.tier, design = info.design, qty = it.quantity;
        var idx = TIER_ORDER.indexOf(tier);
        var newVariant = it.variant_id, newQty = qty;
        if (dir > 0) {
          if (tier === 'First Steps') { newQty = qty + 1; }
          else { newVariant = TIER_DESIGN[TIER_ORDER[idx + 1]][design]; newQty = 1; }
        } else {
          if (tier === 'First Steps' && qty > 1) { newQty = qty - 1; }
          else if (idx > 0) { newVariant = TIER_DESIGN[TIER_ORDER[idx - 1]][design]; newQty = 1; }
          else { return null; } // Sitting: nao desce (lixeira remove)
        }
        if (newVariant === it.variant_id) {
          return post(CHANGE, { id: it.key, quantity: newQty, sections: ids, sections_url: window.location.pathname });
        }
        // troca de tier = remove a linha atual + adiciona o novo variant preservando properties.
        // FIX FLASH: ajusta os BRINDES do novo tier ANTES do unico render (senao o drawer pinta
        // o estado intermediario com o brinde do tier antigo, e so ~3s depois o reconcile remove).
        var newTierNum = TIER_ORDER.indexOf(VARIANT_INFO[newVariant].tier) + 1; // 1,2,3
        return post(CHANGE, { id: it.key, quantity: 0 }).then(function () {
          return post(ADD, { items: [{ id: newVariant, quantity: newQty, properties: it.properties || {} }] });
        }).then(function () {
          return getCart();
        }).then(function (cart2) {
          var wantKnee = includedKnee(newTierNum), wantHelmet = includedHelmet(newTierNum);
          var ops = [];
          if (qtyOf(cart2.items, V.kneeGift)   !== wantKnee)   ops.push([V.kneeGift,   wantKnee]);
          if (qtyOf(cart2.items, V.helmetGift) !== wantHelmet) ops.push([V.helmetGift, wantHelmet]);
          return ops.reduce(function (chain, op) {
            return chain.then(function () { return setLine(op[0], op[1]); });
          }, Promise.resolve());
        }).then(function () {
          // render unico ja com tier + brindes corretos (reconcile posterior nao acha nada a fazer)
          return fetch(CARTURL + '?sections=' + ids.join(',')).then(function (r) { return r.json(); }).then(function (sec) { return { sections: sec }; });
        });
      });
    }

    // refresh: repinta o drawer. skipOpen=true para não forçar abertura.
    // sincroniza a classe is-empty do <cart-drawer> com o estado REAL (tem cart-item?).
    // renderContents so troca o innerHTML do #CartDrawer e nunca mexe nessa classe do pai,
    // entao todo re-render precisa reconciliar is-empty senao o CSS achata o conteudo (tela branca).
    function syncEmptyClass(d) {
      if (d) d.classList.toggle('is-empty', !d.querySelector('.cart-item, cart-item'));
    }
    function refresh(parsed) {
      var d = drawer();
      if (!d) return Promise.resolve();
      if (parsed && parsed.sections) {
        d.renderContents(parsed, true);
        syncEmptyClass(d);
        return Promise.resolve();
      }
      var ids = sectionIds().join(',');
      return fetch(CARTURL + '?sections=' + ids)
        .then(function (r) { return r.json(); })
        .then(function (sec) { d.renderContents({ sections: sec }, true); syncEmptyClass(d); });
    }

    // reconcile: garante KNEE qty >= includedKnee e HELMET qty >= includedHelmet.
    // CRÍTICO: usa ">=", NÃO "==". SÓ adiciona o mínimo faltante — NUNCA remove
    // (preserva extras pagos). Se o tier cair, não força remoção. Idempotente.
    function reconcile() {
      if (window.__snugRec) return Promise.resolve();
      window.__snugRec = true;
      return getCart().then(function (cart) {
        // DEDUP: o bundle deve ter UM único item principal. Se o ATC duplicou (variante
        // default fantasma sem properties), mantém o de MAIOR tier + mais designs e remove os extras.
        var mains = (cart.items || []).filter(function (i) { return VARIANT_INFO[i.variant_id]; });
        if (mains.length > 1) {
          mains.sort(function (a, b) {
            var d = (TIER[b.variant_id] || 0) - (TIER[a.variant_id] || 0);
            if (d) return d;
            return Object.keys(b.properties || {}).length - Object.keys(a.properties || {}).length;
          });
          var ids0 = sectionIds();
          var extras = mains.slice(1);
          return extras.reduce(function (chain, it) {
            return chain.then(function () { return post(CHANGE, { id: it.key, quantity: 0, sections: ids0, sections_url: window.location.pathname }); });
          }, Promise.resolve()).then(function (parsed) {
            return refresh(parsed);
          }).then(function () {
            window.__snugRec = false;
            return reconcile(); // re-reconcilia gifts com o item correto
          });
        }
        var tier = cartTier(cart.items);
        var wantKnee   = includedKnee(tier);
        var wantHelmet = includedHelmet(tier);
        var haveKnee   = qtyOf(cart.items, V.kneeGift);
        var haveHelmet = qtyOf(cart.items, V.helmetGift);

        var ops = [];
        // brinde = variant GIFT ($0). Ajusta para a qtd EXATA do tier (add ao subir, remove ao descer).
        // Os add-ons PAGOS usam outro variant e nunca são tocados aqui.
        if (haveKnee   !== wantKnee)   ops.push([V.kneeGift,   wantKnee]);
        if (haveHelmet !== wantHelmet) ops.push([V.helmetGift, wantHelmet]);

        if (!ops.length) return null; // nada a fazer -> sem repaint, sem loop

        // aplica sequencialmente; último parsed traz as sections atualizadas
        return ops.reduce(function (chain, op) {
          return chain.then(function () { return setLine(op[0], op[1]); });
        }, Promise.resolve()).then(function (parsed) {
          return refresh(parsed);
        });
      }).catch(function (e) {
        console.error('[snugjooy] reconcile', e);
      }).then(function (r) {
        window.__snugRec = false;
        return r;
      });
    }

    // computeSavings: bundleDiscount + cartDiscount.
    // cartDiscount (original_total - total) JA inclui o gift zerado pela Function
    // + descontos automaticos (Buy 2+). NAO somar giftValue separado (dupla contagem).
    function computeSavings() {
      return getCart().then(function (cart) {
        var tier = cartTier(cart.items);
        // SAVINGS = desconto do bundle (preco cheio RISCADO que o cliente ve - preco pago)
        // + valor dos brindes gratis (Matheus 2026-06-03): Free Shipping $15 + Extended Warranty $50
        // + Knee Pads $9 (tier>=2) + Helmet $19 (tier>=3). Le o riscado do DOM p/ bater com a UI.
        var liS = document.querySelector('cart-drawer .cart-item--product-snugjooy-baby-head-protector');
        var strikeEl = liS && liS.querySelector('.cart-item__old-price, s, del');
        var fullVal = strikeEl ? parseFloat(strikeEl.textContent.replace(/[^0-9.]/g, '')) : 0;
        var mainItem = mainBundleItem(cart);
        var paid = mainItem ? (mainItem.final_line_price / 100) : 0;
        var bundleDisc = Math.max(0, fullVal - paid);
        var giftsVal = tier ? (15 + 50 + (tier >= 2 ? 9 : 0) + (tier >= 3 ? 19 : 0)) : 0;
        var total = bundleDisc + giftsVal;
        var box = document.getElementById('sj-savings');
        var val = document.getElementById('sj-savings-val');
        if (box && val) {
          if (total > 0.005) {
            val.textContent = '-$' + total.toFixed(2);
            box.classList.remove('sj-savings--hidden');
          } else {
            box.classList.add('sj-savings--hidden');
          }
        }
      }).catch(function () {});
    }

    // ---- ação do usuário: guard anti-double-click, reconcilia + recomputa savings ----
    // fila serial: encadeia ações em vez de descartar cliques rápidos (toggles, steppers)
    function userAction(fn) {
      setBusy(true);
      window.__snugQueue = (window.__snugQueue || Promise.resolve())
        .then(function () { return Promise.resolve().then(fn); })
        .then(function (parsed) { return refresh(parsed); })
        .then(function () { return reconcile(); })
        .then(function () { return computeSavings(); })
        .then(function () { return decorateImages(); })
        .catch(function (err) { console.error('[snugjooy]', err); })
        .then(function () { setBusy(false); });
      return window.__snugQueue;
    }

    // ---- handlers (event-delegation no document, sobrevive a innerHTML swaps) ----
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sj]');
      if (!btn) return;
      e.preventDefault();
      var act = btn.getAttribute('data-sj');

      if (act === 'knee-add') {
        userAction(function () {
          return getCart().then(function (c) { return setLine(V.knee, qtyOf(c.items, V.knee) + 1); });
        });
      } else if (act === 'knee-remove') {
        userAction(function () {
          return getCart().then(function (c) { return setLine(V.knee, Math.max(0, qtyOf(c.items, V.knee) - 1)); });
        });
      } else if (act === 'helmet-add') {
        userAction(function () {
          return getCart().then(function (c) { return setLine(V.helmet, qtyOf(c.items, V.helmet) + 1); });
        });
      } else if (act === 'helmet-remove') {
        userAction(function () {
          return getCart().then(function (c) { return setLine(V.helmet, Math.max(0, qtyOf(c.items, V.helmet) - 1)); });
        });
      }
    });

    // stepper do item principal: intercepta +/- nativos (capture) e troca o TIER em vez de mudar qty do variant
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('cart-drawer button[name="plus"], cart-drawer button[name="minus"]');
      if (!btn) return;
      // só intercepta se o item principal for um variant de tier (bundle Snugjooy)
      e.preventDefault();
      e.stopImmediatePropagation();
      var dir = btn.name === 'plus' ? 1 : -1;
      userAction(function () { return swapMain(dir); });
    }, true);

    // remover o BUNDLE principal (lixeira) leva os BRINDES junto (Matheus 2026-06-03):
    // o remove nativo do tema so tira a linha clicada e deixa o brinde orfao. Interceptamos a
    // lixeira do item principal e zeramos principal + gifts numa unica transacao (render no fim).
    document.addEventListener('click', function (e) {
      var rm = e.target.closest('cart-drawer cart-remove-button, cart-drawer a[href*="quantity=0"]');
      if (!rm) return;
      var li = rm.closest('.cart-item');
      if (!li || li.className.indexOf('cart-item--product-snugjooy-baby-head-protector') < 0) return; // brinde/outro: deixa o nativo
      e.preventDefault();
      e.stopImmediatePropagation();
      userAction(function () {
        return getCart().then(function (cart) {
          var main = mainBundleItem(cart);
          if (!main) return null;
          return post(CHANGE, { id: main.key, quantity: 0 }).then(function () {
            return getCart();
          }).then(function (c2) {
            var ops = [];
            [V.kneeGift, V.helmetGift].forEach(function (g) { if (qtyOf(c2.items, g) > 0) ops.push(g); });
            return ops.reduce(function (chain, g) {
              return chain.then(function () { return post(CHANGE, { id: String(g), quantity: 0 }); });
            }, Promise.resolve());
          }).then(function () {
            return fetch(CARTURL + '?sections=' + sectionIds().join(',')).then(function (r) { return r.json(); }).then(function (sec) { return { sections: sec }; });
          });
        });
      });
    }, true);

    // toggles disparam em change (checkbox)
    document.addEventListener('change', function (e) {
      var tog = e.target.closest('[data-sj-toggle]');
      if (!tog) return;
      var which = tog.getAttribute('data-sj-toggle');
      var vid = which === 'warranty' ? V.warranty : (which === 'shipping' ? V.shipping : 0);
      if (!vid) return;
      var on = tog.checked; // estado desejado após o clique
      userAction(function () { return setLine(vid, on ? 1 : 0); });
    });

    // ---- countdown 10:00, persiste início em localStorage; reinicia ao zerar ----
    var TIMER_KEY = 'sj_timer_start_v2'; // v2: reset do start ao mudar 10min->4min
    var TIMER_LEN = 4 * 60 * 1000; // 4 min (Matheus 2026-06-03: timer unico "Cart + free gifts reserved for 04:00")
    function tickTimer() {
      var el = document.getElementById('sj-timer-val');
      if (!el) return;
      var start = parseInt(localStorage.getItem(TIMER_KEY) || '0', 10);
      var now = Date.now();
      if (!start || (now - start) >= TIMER_LEN) {
        start = now; // reinicia para manter urgência
        try { localStorage.setItem(TIMER_KEY, String(start)); } catch (e) {}
      }
      var remain = Math.max(0, TIMER_LEN - (now - start));
      var totalSec = Math.round(remain / 1000);
      var m = Math.floor(totalSec / 60);
      var s = totalSec % 60;
      el.textContent = (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
    }
    function startTimer() {
      if (window.__snugTimer) clearInterval(window.__snugTimer);
      tickTimer();
      window.__snugTimer = setInterval(tickTimer, 1000);
    }

    // ---- observer: roda reconcile 1x por abertura do drawer (classe 'active') ----
    function watchDrawer() {
      var d = drawer();
      if (!d || d.__snugObserved) return;
      d.__snugObserved = true;
      var obs = new MutationObserver(function () {
        var active = d.classList.contains('active');
        if (active) {
          if (!d.__snugWasActive) { d.__snugWasActive = true; startTimer(); }
          // reconcile idempotente: só adiciona brinde faltante (não re-renderiza se nada falta -> sem loop)
          reconcile().then(computeSavings).then(decorateImages);
        } else {
          d.__snugWasActive = false;
        }
      });
      obs.observe(d, { attributes: true, attributeFilter: ['class'] });
    }

    function boot() {
      watchDrawer();
      startTimer();
      reconcile().then(computeSavings).then(decorateImages);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    // o panel é repintado pelo tema; re-arma timer/observer após cada repaint
    document.addEventListener('DOMContentLoaded', boot);
  })();

// ==== SNUGJOOY ATC SYSTEM v3 — orientado a evento nativo do picker ====
// Robustez: consome o CustomEvent 'torres:variant-change' que o torres-bundle-picker
// emite em updateForm(). Sem setTimeout magico de sync, sem capture-hack, sem MutationObserver de slots.
// O picker e a fonte de verdade; este modulo cuida da APRESENTACAO (botoes + progressao + gifts).
(function () {
  if (window.__sjAtcV3) return;
  window.__sjAtcV3 = true;

  var TEXT_IDLE   = "Choose your baby's stage";
  var TEXT_GRAY   = 'Select all designs to continue';
  var TEXT_ACTIVE = 'Protect Her Now';
  var SUB_IDLE    = 'Select a bundle above to continue';
  var SUB_GRAY    = 'Pick a design for each slot above';
  var SUB_ACTIVE  = '🔒 Secure checkout · 30-Day Guarantee · Free shipping';

  function injectStyles() {
    if (document.getElementById('sj-atc-css')) return;
    var s = document.createElement('style');
    s.id = 'sj-atc-css';
    s.textContent = [
      '.product-form__buttons{visibility:hidden;height:0;overflow:hidden;padding:0!important;margin:0!important}',
      '.sj-outer-wrap{padding:16px 0 4px}',
      '.sj-outer-wrap.sj-hidden{display:none!important}',
      '.sj-card-btn-wrap{display:none!important;padding:14px 0 4px}',
      '.torres-bp__card.is-selected .sj-card-btn-wrap{display:block!important}',
      '.sj-btn{display:block;width:100%;padding:17px 20px;border:none;border-radius:8px;font-size:17px;font-weight:700;letter-spacing:.3px;cursor:default;text-align:center;line-height:1.3;transition:background .15s,color .15s}',
      '.sj-btn-sub{display:block;text-align:center;font-size:12px;color:#999;margin-top:7px}',
      '.torres-bp__slot.sj-slot-hidden{display:none!important}',
      '.snugly-gift-card__save{background:#fee2e2!important;color:#dc2626!important;font-size:12px!important;font-weight:800!important;padding:2px 6px!important;border-radius:20px!important;letter-spacing:-.2px!important;display:inline-block!important;text-decoration:none!important}',
      '.snugly-gift-card__save.sj-save-off{display:none!important}',
      '.snugly-divider,.sj-unlock-amt{color:#16a34a!important}',
      '.snugly-divider{-webkit-text-stroke-color:#16a34a!important}', /* "UNLOCK UP TO": stroke era roxo #4E35D9 -> verde (color ja era verde; o stroke roxo fazia parecer roxo) */
      '.snugly-divider .sj-unlock-amt{-webkit-text-stroke:0!important;color:#16a34a!important}',
      '.snugly-divider .sj-light{color:#1a1a1a!important}'
    ].join('\n');
    document.head.appendChild(s);
  }

  function cardUnits(card) { var u = parseInt(card.dataset.units, 10); return isNaN(u) ? 1 : u; }
  function readDesigns(card) {
    return Array.from(card.querySelectorAll('.torres-bp__slot')).map(function (slot) {
      var sel = slot.querySelector('.torres-bp__swatch.is-selected');
      return sel ? sel.dataset.torresDesign : '';
    });
  }
  function isComplete(card) {
    var u = cardUnits(card), designs = readDesigns(card);
    for (var i = 0; i < u; i++) { if (!designs[i]) return false; }
    return true;
  }
  function activeCard(P) {
    return P.cards.find(function (c) { return c.classList.contains('is-selected'); });
  }

  function applyBtnState(btn, sub, state) {
    if (state === 'active') {
      btn.style.setProperty('background', '#16a34a', 'important');
      btn.style.setProperty('color', '#fff', 'important');
      btn.style.setProperty('cursor', 'pointer', 'important');
      btn.textContent = TEXT_ACTIVE; sub.textContent = SUB_ACTIVE;
    } else {
      btn.style.setProperty('background', '#d1d5db', 'important');
      btn.style.setProperty('color', '#6b7280', 'important');
      btn.style.setProperty('cursor', 'default', 'important');
      btn.textContent = state === 'gray' ? TEXT_GRAY : TEXT_IDLE;
      sub.textContent = state === 'gray' ? SUB_GRAY : SUB_IDLE;
    }
  }

  function getMainAtcBtn() {
    return document.querySelector('product-form button[name="add"]') ||
           document.querySelector('button[name="add"]');
  }

  var atcBusy = false; // lock anti-duplo-clique: impede 2+ adds do mesmo bundle
  // ids das sections do drawer p/ re-render (padrao Shopify): SEM isso o drawer abre VAZIO.
  function sjSectionIds() {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.getSectionsToRender === 'function') {
      try { return d.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) {}
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }
  function openDrawer(drawer) {
    if (!drawer) { window.location.href = '/cart'; return; }
    if (typeof drawer.open === 'function') { drawer.open(); return; }
    // fallback manual de abertura (caso a API do tema mude)
    drawer.classList.add('active', 'animate');
    document.documentElement.classList.add('cart-drawer-open');
  }
  function addToCart() {
    if (atcBusy) return;
    // Adiciona via FormData do product-form (variant + properties que o picker JA setou).
    // CRITICO: pede 'sections' p/ re-renderizar o drawer com o item novo (senao abre vazio = "nada aparece").
    var form = document.querySelector('product-form form') || document.querySelector('form[action*="/cart/add"]');
    if (!form) { window.location.href = '/cart'; return; }
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) return; // sem variante resolvida: nao faz nada (botao gray)
    atcBusy = true;
    var fd = new FormData(form);
    fd.append('sections', sjSectionIds().join(','));
    fd.append('sections_url', window.location.pathname);
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && data && data.sections && typeof drawer.renderContents === 'function') {
          try { drawer.renderContents(data, true); } catch (e) {}
        }
        // FIX TELA BRANCA (1o add em carrinho vazio = toda guia anonima): renderContents troca o
        // innerHTML do #CartDrawer, mas NAO mexe nas classes do <cart-drawer> pai. Se a pagina
        // carregou com cart vazio, <cart-drawer class="is-empty"> persiste e a regra
        // `cart-drawer.is-empty .cart-drawer__body{height:0}` achata o item recem-adicionado ->
        // drawer abre BRANCO. O add deu certo (ha item no cart): removemos is-empty p/ o grid normalizar.
        if (drawer) drawer.classList.remove('is-empty');
        openDrawer(drawer); // dispara watchDrawer -> reconcile (brindes) + savings + decorateImages
      })
      .catch(function () { window.location.href = '/cart'; }) // falha de rede: MOSTRA o carrinho, nunca tela branca
      .finally(function () { setTimeout(function () { atcBusy = false; }, 1200); });
  }

  function applyProgressive(P, card) {
    var slots = Array.from(card.querySelectorAll('.torres-bp__slot'));
    if (slots.length <= 1) { slots.forEach(function (s) { s.classList.remove('sj-slot-hidden'); }); return; }
    slots.forEach(function (slot, i) { slot.classList.toggle('sj-slot-hidden', i > P.reveal); });
  }

  // Fronteira de progressao DERIVADA DO ESTADO (nao de transicoes):
  // revela todos os slots ja preenchidos + o primeiro vazio. Se todos cheios, revela todos.
  // Robusto ao slot0 que o picker pre-seleciona (ex: Bee) — sem depender de "design mudou".
  function computeReveal(card) {
    var u = cardUnits(card), designs = readDesigns(card), firstEmpty = -1;
    for (var i = 0; i < u; i++) { if (!designs[i]) { firstEmpty = i; break; } }
    return (firstEmpty === -1) ? (u - 1) : firstEmpty;
  }

  function syncPicker(P) {
    var card = activeCard(P);
    P.outerWrap.classList.toggle('sj-hidden', !!card);
    P.cards.forEach(function (c, idx) {
      var d = P.inlineMap[idx];
      if (!d) return;
      if (c.classList.contains('is-selected')) {
        P.reveal = computeReveal(c);
        applyProgressive(P, c);
        applyBtnState(d.btn, d.sub, isComplete(c) ? 'active' : 'gray');
      }
    });
  }

  var pickers = [];

  function initPicker(root) {
    if (root.__sjV3) return; root.__sjV3 = true;
    var container = root.querySelector('.torres-bp__cards');
    if (!container) return;
    var cards = Array.from(root.querySelectorAll('.torres-bp__card'));

    var outerWrap = document.createElement('div'); outerWrap.className = 'sj-outer-wrap';
    var outerBtn = document.createElement('button'); outerBtn.type = 'button'; outerBtn.className = 'sj-btn';
    var outerSub = document.createElement('span'); outerSub.className = 'sj-btn-sub';
    outerWrap.appendChild(outerBtn); outerWrap.appendChild(outerSub);
    container.parentNode.insertBefore(outerWrap, container.nextSibling);
    applyBtnState(outerBtn, outerSub, 'idle');

    var inlineMap = {};
    var P = { root: root, cards: cards, container: container, outerWrap: outerWrap,
              inlineMap: inlineMap, lastBundle: '', reveal: 0, prevDesigns: [] };

    cards.forEach(function (card, idx) {
      var host = card.querySelector('.torres-bp__designs-host');
      if (!host) return;
      var wrap = document.createElement('div'); wrap.className = 'sj-card-btn-wrap';
      var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'sj-btn';
      var sub = document.createElement('span'); sub.className = 'sj-btn-sub';
      wrap.appendChild(btn); wrap.appendChild(sub);
      host.parentNode.insertBefore(wrap, host.nextSibling);
      applyBtnState(btn, sub, 'gray');
      btn.type = 'button'; // defensivo: nunca submeter form (evita redirect/tela branca)
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        var c = activeCard(P);
        if (c && isComplete(c)) addToCart(P);
      });
      inlineMap[idx] = { btn: btn, sub: sub };
    });

    root.__sjP = P;
    pickers.push(P);
    syncPicker(P);
  }

  // listener do evento NATIVO do picker (API oficial torres).
  // Toda mudanca de tier/design re-sincroniza; a fronteira de progressao
  // e derivada do estado atual dentro de syncPicker (computeReveal).
  document.addEventListener('torres:variant-change', function () {
    pickers.forEach(syncPicker);
  });

  function initGiftBadges() {
    document.querySelectorAll('.snugly-gift-card__save').forEach(function (save) {
      if (save.dataset.sjGiftInit) return;
      save.dataset.sjGiftInit = '1';
      var orig = save.textContent.trim().replace(/^-/, '');
      var giftCard = save.closest('.snugly-gift-card');
      function syncGift() {
        var unlocked = giftCard && giftCard.classList.contains('is-unlocked');
        var freeEl = giftCard && giftCard.querySelector('.snugly-gift-card__free');
        var freeVisible = freeEl && freeEl.offsetParent !== null && getComputedStyle(freeEl).display !== 'none';
        save.classList.toggle('sj-save-off', unlocked || freeVisible);
        if (!unlocked && !freeVisible) save.textContent = orig;
      }
      syncGift();
      if (giftCard) new MutationObserver(syncGift).observe(giftCard, { attributes: true, attributeFilter: ['class'] });
    });
  }

  // FIX TELA BRANCA MOBILE: a barra Sticky ATC ("Protect her head") dispara o handleSubmit
  // NATIVO do <product-form> do tema, que faz window.location='/checkout' ou '/cart' (navega
  // = tela branca). Interceptamos o submit do form E o clique da sticky em CAPTURE phase,
  // matamos a navegacao nativa e usamos o MESMO add AJAX (addToCart) do botao verde.
  var guardArmed = false;
  function armWhiteScreenGuard() {
    if (guardArmed) return;
    guardArmed = true;
    function pickerComplete() {
      var done = false;
      pickers.forEach(function (P) { var c = activeCard(P); if (c && isComplete(c)) done = true; });
      return done;
    }
    function scrollToPicker() {
      var p = document.querySelector('.torres-bundle-picker');
      if (p) p.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    // 1) qualquer submit do product-form -> AJAX (nunca deixar navegar)
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (f && f.matches && f.matches('form[action*="/cart/add"], product-form form')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (pickerComplete()) addToCart(); else scrollToPicker();
      }
    }, true);
    // 2) clique na barra Sticky ATC nativa -> AJAX (em vez do submit que navega)
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[id^="SectionAtcBtn-"], .sticky-atc__add_button, [data-skip-cart-button]');
      if (!b) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (pickerComplete()) addToCart(); else scrollToPicker();
    }, true);
  }

  function boot() {
    injectStyles();
    document.querySelectorAll('.torres-bundle-picker').forEach(initPicker);
    initGiftBadges();
    armWhiteScreenGuard();
  }

  // ARMA O GUARD JA (sincrono, antes do boot): fecha a corrida no mobile onde o cliente
  // toca a sticky/submit antes do addon bootar. Os listeners sao no document e leem
  // pickers[] no momento do clique, entao armar cedo e seguro.
  armWhiteScreenGuard();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  setTimeout(boot, 1200);
  setTimeout(boot, 2500);
})();
